import { getStoreBusinessDate } from "../utilities/storeTime";
import { isNoShowActualShift, shiftDurationHours } from "./content/reporting/prebuilt/reports/_shared/laborMath";

export const SALES_REMINDER_LOOKBACK_DAYS = 14;

export function offsetSalesDate(dateString, offset) {
  const date = new Date(`${dateString}T12:00:00Z`);
  date.setUTCDate(date.getUTCDate() + offset);
  return date.toISOString().slice(0, 10);
}

export function formatSalesDate(date) {
  return new Date(`${date}T12:00:00Z`).toLocaleDateString("en-US", {
    timeZone: "UTC", weekday: "long", month: "short", day: "numeric", year: "numeric",
  });
}

export function canShowManualSalesReminder(store, permissionRole) {
  return Boolean(
    store?.id && store.manual_sales_input_enabled && !store.pos_provider &&
    store.status !== "closed" && store.onboarding_status !== "inactive" &&
    ["company_manager", "company_admin", "rightwork_internal"].includes(permissionRole)
  );
}

export function previousBusinessDate(store) {
  const today = getStoreBusinessDate(store.timezone, store.start_qhnum);
  return offsetSalesDate(today, -1);
}

export function missingSalesDates({ yesterday, sales, actualShifts, operatingHours, includeYesterday }) {
  const workedDates = new Set(actualShifts.filter((row) => {
    if (isNoShowActualShift(row)) return false;
    const hours = shiftDurationHours(row.shift_start, row.shift_end, row.total_break);
    return Number.isFinite(hours) && hours > 0;
  }).map((row) => row.business_date || row.date_start));

  return Array.from({ length: SALES_REMINDER_LOOKBACK_DAYS }, (_, index) =>
    offsetSalesDate(yesterday, index - SALES_REMINDER_LOOKBACK_DAYS + 1)
  ).filter((date) =>
    (workedDates.has(date) || (includeYesterday && date === yesterday)) &&
    !hasActualSales(sales, date) && !isClosedForSales(date, operatingHours)
  );
}

export function hasActualSales(rows, date) {
  // An explicitly entered zero is complete, too.
  return rows.some((row) => row.date === date && row.metric === "Revenue" &&
    row.value !== null && row.value !== "" && Number.isFinite(Number(row.value)));
}

export function isClosedForSales(date, operatingHours) {
  const hours = operatingHours.find((row) => row.date === date);
  return hours?.open_time != null && hours?.close_time != null &&
    Number(hours.open_time) === Number(hours.close_time);
}

export function validSalesAmount(value) {
  return String(value).trim() !== "" && Number.isFinite(Number(value)) && Number(value) >= 0;
}
